import { DropDownButton } from "./DropDownButton";
import { translate } from "../../utils/translate";
import { Badge } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { ProjectAssistantHub, ProjectAssistantHubLines } from "../../utils/signalR/projectAssistantHub";
import { snackbar } from "../../redux/snackbar";
import { useDispatch } from "react-redux";
import { useApiClient } from "../../components/ApiProvider";

export function UsersOnPageBtn({ users = [] }) {
  const usersList = useMemo(() => {
    return users.map((i, id) => ({ text: i, id }));
  }, [users]);
  return (
    <Badge badgeContent={usersList.length} color="error" data-testid="tb_users_on_page">
      <DropDownButton title={translate("User on project")} items={usersList} id={"users"} menuId="users-menu">
        <span className="ico icon-users" />
      </DropDownButton>
    </Badge>
  );
}

export function UsersOnProject({ projectId, update, onProjectChanged, hubLines = ProjectAssistantHubLines }) {
  const [token, setToken] = useState(null);
  const apiClient = useApiClient();
  const dispatch = useDispatch();

  useEffect(() => {
    const retrieveToken = async () => {
      const token = await apiClient.getAccessToken();
      setToken(token);
    };
    retrieveToken();
  }, [apiClient]);

  useEffect(() => {
    if (!token) return;

    const projectAssistantHub = new ProjectAssistantHub(token);
    let UserIsNotified = false;
    const getInvokeParams = (method) => {
      const params = [method];
      if (projectId) {
        params.push(`${projectId}`); //Id must be a string
      }
      return params;
    };

    const sendJoinProject = async () => {
      UserIsNotified = false;

      await projectAssistantHub.hub.invoke(...getInvokeParams(hubLines.joinProject));
    };

    const joinProject = (updatedProjectId, username) => {
      //Check if the user is joining the project that this component is watching
      //Only compare project id if it is defined. Otherwise this component is loaded on the DepartmentsView page
      if (projectId != undefined && updatedProjectId != projectId) {
        return;
      }

      dispatch(
        snackbar.actions.add({
          id: "UserJoinedProject" + username,
          severity: "warning",
          message: translate(
            projectId != undefined ? "User joined the project" : "User joined the department overview",
            { userName: username }
          ),
          autoHideDuration: 4000,
        })
      );
    };
    const usersOnProjectChanged = (updatedProjectId, usersOnProject) => {
      //Check if the user is joining the project that this component is watching
      //Only compare project id if it is defined. Otherwise this component is loaded on the DepartmentsView page
      if (projectId != undefined && updatedProjectId != projectId) {
        return;
      }

      if (usersOnProject.length > 1 && !UserIsNotified) {
        dispatch(
          snackbar.actions.add({
            id: "usersOnProject" + usersOnProject.length,
            severity: "warning",
            message: translate(
              projectId != undefined ? "Users are watching the project" : "Users are watching department overview",
              { userNames: usersOnProject.join(", ") }
            ),
            autoHideDuration: 4000,
          })
        );
      }
      UserIsNotified = true;
      update({
        users: usersOnProject,
      });
    };

    projectAssistantHub.onConnected(sendJoinProject);
    projectAssistantHub.on(hubLines.joinProject, joinProject);
    projectAssistantHub.on(hubLines.usersOnProjectChanged, usersOnProjectChanged);
    projectAssistantHub.on(hubLines.leftProject);
    onProjectChanged && projectAssistantHub.on(hubLines.projectChanged, onProjectChanged);

    return () => {
      projectAssistantHub.hub.invoke(...getInvokeParams(hubLines.leaveProject));
      projectAssistantHub.off(hubLines.joinProject, joinProject);
      projectAssistantHub.off(hubLines.usersOnProjectChanged, usersOnProjectChanged);
      projectAssistantHub.off(hubLines.leftProject);
      onProjectChanged && projectAssistantHub.off(hubLines.projectChanged, onProjectChanged);
    };
  }, [projectId, dispatch, update, onProjectChanged, hubLines, token]);
  return null;
}
